export const ENV_JS = {
  CALLPY_PHP_SERVER: 'https://kkombeto.dev.callpy.com/',
  CALLPY_SERVER: 'kkombeto.dev.callpy.com',
  CALLPY_LANGUAGE: 'ru',
  CALLPY_RPLX_SERVER: 'https://rp.kkombeto.dev.callpy.com',
  CALLPY_ORIGIN_URL: 'https://kkombeto.dev.callpy.com',
  CALLPY_CLIENT_DATA: {
    SITE_URL: 'https://test.dev-spw.com/',
    SERVER: 'test.dev-spw.com'
  },
  CALLPY_STORAGE_NAME: 'CallpyApp'

}